export default customElements.define('w-toggle', class Toggle extends wealthify.CustomElementBaseClass {

    constructor() {
        const styleSelector = 'c-toggle';
        const config = {
            styleSelector: styleSelector,
            templateHTML: `
            <button class='${styleSelector}__container' data-root>
                <div class='${styleSelector}__control' data-control>
                    <w-icon class='${styleSelector}__icon' data-icon type="tick"></w-icon>
                    <input type="checkbox" class='${styleSelector}__input u-display__hidden' aria-hidden="true" tabindex="-1" data-checkbox>
                </div>
                <span class='${styleSelector}__text-label' data-textlabel></span>
            </button>`,
            cacheDom: [ 'data-checkbox', 'data-icon', 'data-control', 'data-textlabel' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(styleSelector);
            this.dom.root.addEventListener('click', () => this._toggleActive(this));
        };
    }

    static get observedProps() {
        return [
            new wealthify.Prop('activated', {
                type: wealthify.propTypes.Boolean(),
                default: false
            }),
            new wealthify.Prop('focusable', {
                default: true,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('label', { required: true }),
            new wealthify.Prop('showlabel', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    get propCallbacks() {
        return { 
            activated: () => this._updateToggle(),
            label: () => {
                this.dom.textlabel.innerHTML = this.label;
                this.dom.root.setAttribute('aria-label', this.label);
            },
            showlabel: (showlabel) => {
                const classListAction = showlabel ? 'remove' : 'add';

                this.dom.textlabel.classList[classListAction]('u-display__none');
            },
            focusable: () => {
                if (this.focusable) {
                    this.dom.root.removeAttribute('tabindex');
                } else {
                    this.dom.root.setAttribute('tabindex', '-1');
                }
            }
        };
    }

    _updateToggle() {
        const classListAction = this.activated ? 'add' : 'remove';

        this.dom.control.classList[classListAction](`${this.styleSelector}__control--activated`);
        this.dom.icon.classList[classListAction](`${this.styleSelector}__icon--activated`);

        const iconType = this.activated ? 'tick' : 'cross';

        this.dom.icon.type = iconType;
    }

    _toggleActive(component) {
        component.activated = !component.activated;
        component._updateToggle();
        component._eventDispatch(component);
    }

    _eventDispatch (component) {
        component.dispatchEvent(new Event('valuechange'));
    }
});